import React from "react";

export default function Cursor({ cursorTop }) {
  return (
    <div className="cursor-container" style={{ top: cursorTop + "px" }}>
      <span className="cursor-line" />
      <span className="cursor-triangle" />
    </div>
  );
}
